import { ContactCornSchema } from '@eigtech/contacts-types';
import { SubtotalLineItemSchema } from '@eigtech/line-items';
import { z } from 'zod';
import { BaseInvoicingSchema, InvoicingTypeEnum } from './service.js';
import { StatusEnum, StatusSchema } from './status.js';
export const InvoiceStatusSchema = StatusSchema;
export const InvoiceStatusEnum = InvoiceStatusSchema.enum;
export const InvoiceCustomerSchema = z.object({
    name: z.string().optional(),
    id: z.string().optional(),
    contactId: ContactCornSchema,
});
export const InvoiceSchema = BaseInvoicingSchema.extend({
    type: z.literal(InvoicingTypeEnum.invoice),
    customer: InvoiceCustomerSchema,
    total: SubtotalLineItemSchema,
});
export const PaidInvoiceSchema = InvoiceSchema.extend({
    status: z.literal(StatusEnum.paymentMade),
});
export const isInvoice = (entity) => InvoiceSchema.safeParse(entity).success;
export const isPaidInvoice = (entity) => PaidInvoiceSchema.safeParse(entity).success;
